import React from 'react';
import {Col, Row} from 'react-bootstrap';
import {mobilePortrait, tabletPortrait} from 'shared/Breakpoints';
import {Shimmer} from 'shared/components/Shimmer';
import styled from 'styled-components';

export const PlaceholderLoader = () => {
    return (
        <Container>
            <Row>
                <Col>
                    <FauxTabs />
                </Col>
                <Col>
                    <FauxTabs />
                </Col>
                <Col>
                    <FauxTabs />
                </Col>
                <Col>
                    <FauxTabs />
                </Col>
            </Row>
            <Row>
                <Col>
                    <FauxField />
                </Col>
            </Row>
            <Row>
                <Col>
                    <FauxField />
                </Col>
                <Col>
                    <FauxField />
                </Col>
            </Row>
            <Row>
                <Col>
                    <FauxField />
                </Col>
                <Col>
                    <FauxField />
                </Col>
            </Row>
            <Row>
                <Col>
                    <FauxField />
                </Col>
                <Col>
                    <FauxField />
                </Col>
            </Row>
            <Row>
                <Col>
                    <FauxField />
                </Col>
                <Col>
                    <FauxField />
                </Col>
            </Row>
            <Row>
                <Col>
                    <FauxField />
                </Col>
                <Col>
                    <FauxField />
                </Col>
            </Row>

            <FauxContainres />
        </Container>
    );
};

const FauxTabs = styled(Shimmer)`
    height: 30px;
    border-radius: 8px;
`;

const FauxField = styled(Shimmer)`
    height: 30px;
    border-radius: 8px;
    margin: 15px 0;
`;

const FauxContainres = styled(Shimmer)`
    height: 225px;
    margin-top: 15px;
    border-radius: 8px;
`;

const Container = styled.div`
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    background: white;
    padding: 15px;
    max-width: 400px;

    ${mobilePortrait`
        max-width: initial;    
    `}

    ${tabletPortrait`
        max-width: initial;
        padding: 90px 50px 0;    
    `}
`;
